<script>
import VueSlider from '@components/slider/vue-slider.vue';
import { workoutComputed, workoutMethods } from '@state/helpers';

export default {
  components: {
    VueSlider,
  },
  props: {},
  data() {
    return {
      value: 0,
      marks: [0, 20, 40, 60, 80, 100],
    };
  },
  computed: {
    ...workoutComputed,
    text() {
      if (this.value <= 20) return `There's nothing left in the tank.`;
      if (this.value > 20 && this.value <= 40) return 'Tired, but in the sweet spot.';
      if (this.value > 40 && this.value <= 60) return 'Great workout, but need a little more.';
      if (this.value > 60 && this.value <= 80) return 'A light workout, but broke a sweat.';
      if (this.value > 80 && this.value <= 100) return 'A lot of energy left.';
      return 'Nothing';
    },
  },
  mounted() {},
  methods: {
    ...workoutMethods,
    setValue(val) {
      this.value = val;
      this.setUpdatePostWorkoutReview({
        ...this.selectedWorkout.programDayWorkout.clientInput.postWorkoutReview,
        remainingEnergyPercent: val,
      });
    },
  },
};
</script>

<template>
  <div class="details-section">
    <div class="content">
      <div class="title-container">
        <p class="title">Amazing!</p>
        <p class="sub-title">You completed the workout. Great work! Please take a few minutes to tell me how the workout went.</p>
      </div>
      <div class="actions">
        <p class="title">What’s your energy level?</p>
        <p class="percentage">{{ value }}<strong>%</strong></p>
        <VueSlider :value="value" :marks="marks" @set-value="setValue($event)" />
        <p class="text-value">{{ text }}</p>
      </div>
    </div>
    <BaseButton @click="$emit('next-card')" class="button btn-primary large">Next</BaseButton>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.details-section {
  align-items: center;
  color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding-bottom: 3rem;
  padding-top: 3rem;
  width: 100%;

  .content {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
    width: 75%;

    @include media('xl', null) {
      width: 65%;
    }

    .title-container {
      align-items: center;
      display: flex;
      flex-direction: column;
    }

    .title {
      color: #fff;
      font-family: $base-font-family;
      font-size: 40px;
      font-style: normal;
      font-weight: bold;
      line-height: 33px;
      margin-bottom: 2rem;
      @media screen and (min-width: 1100px) {
        @include calc-font-size(4.3);
      }
    }
    .sub-title {
      color: #fff;
      font-family: $proxima-nova;
      font-size: 18px;
      font-style: normal;
      font-weight: 300;
      line-height: 21px;
      margin-bottom: 2rem;
      mix-blend-mode: normal;
      opacity: 0.7;
      text-align: center;
    }
    .actions {
      margin-bottom: 1.6rem;
      width: 100%;
      .title {
        color: #fff;
        font-family: $proxima-nova;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 23px;
        text-align: center;
      }
      .percentage {
        color: #fff;
        font-family: $base-font-family;
        font-size: 54px;
        font-style: normal;
        font-weight: bold;
        line-height: 63px;
        margin-top: 5rem;
        text-align: center;
        strong {
          font-size: 24px;
          font-weight: 400;
        }
      }
      .text-value {
        margin-top: 3rem;
        text-align: center;
      }
    }
  }
  .btn-primary {
    background-color: transparent;
    border: 1px white solid;
    line-height: unset;
    -webkit-transition-duration: 0.3s;
    width: 50%;
    @include calc-font-size(1.4);
    &:hover {
      background-color: rgba(#1c1c1c, 0.3);
      border: 1px rgba(#1c1c1c, 0.3) solid;
    }
  }
}
</style>
